import { NotificationStatus } from '@/shared/lib';
import type { StatusOption } from './filter.types';

export const STATUS_OPTIONS: StatusOption[] = [
  { value: NotificationStatus.ACTIVE, label: 'Vigente' },
  { value: NotificationStatus.CLOSED, label: 'Encerrada' },
  { value: NotificationStatus.DRAFT, label: 'Rascunho' },
];
